const moment = require('moment');

import {restService} from '../rest.js';

const restServiceInstance = new restService();
function indicadorFacturacion() {
  this.invoices = [];
  this.filteredInvoices = [];
  this.invoicesResult = [];
  this.totalMXN = 0;
  this.invoicesResult = [];
  this.calculateInvoicesAmmount = function (
    sucursal,
    fechaIniMillis,
    fechaFinMillis,
  ) {
    console.log('params', sucursal, moment(fechaIniMillis), moment(fechaFinMillis));
    this.filteredInvoices = [];
    const facturacion = this;
    return new Promise(((resolve, reject) => {
      facturacion.invoices.forEach((invoice) => {
        if (
          invoice &&
          invoice.state &&
          invoice.currency_id &&
          invoice.currency_id.length > 0 &&
          invoice.amount_total &&
          invoice.operating_unit_id &&
          (invoice.operating_unit_id[1] == sucursal || sucursal == 'all') &&
          invoice.type_document_id &&
          invoice.type_document_id[0] == 1
        ) {
          facturacion.filteredInvoices.push(invoice);
        }
      });
      facturacion.filteredInvoices.forEach((invoice) => {
        if (invoice.date_invoice) {
          const dateMillis = moment(invoice.date_invoice).valueOf();
          if (
            invoice.date_invoice &&
            dateMillis > fechaIniMillis &&
            dateMillis < fechaFinMillis
          ) {
            facturacion.totalMXN += invoice.amount_total * invoice.tipo_cambio;
            facturacion.invoicesResult.push(invoice);
          }
        }
      });
      console.log(facturacion.totalMXN, 'TOTAL');
      resolve(facturacion.totalMXN);
    }));
  };

  this.calculateInvoicesDetailedAmmount = function (
    sucursal,
    fechaIniMillis,
    fechaFinMillis,
  ) {
    console.log('params', sucursal, moment(fechaIniMillis).toString(), moment(fechaFinMillis).toString());
    const facturacion = this;
    this.filteredInvoices = [];
    return new Promise(((resolve, reject) => {
      facturacion.invoices.forEach((invoice) => {
        if (
          invoice &&
          invoice.state &&
          invoice.currency_id &&
          invoice.currency_id.length > 0 &&
          invoice.amount_total &&
          invoice.operating_unit_id &&
          (invoice.operating_unit_id[1] == sucursal || sucursal == 'all') &&
          invoice.type_document_id &&
          invoice.type_document_id[0] == 1
        ) {
          facturacion.filteredInvoices.push(invoice);
        }
      });
      const hashMapCountResult = {};
      const openInvoices = [];
      const paidInvoices = [];
      facturacion.filteredInvoices.forEach((invoice) => {
        if (invoice.invoice_datetime) {
          const dateMillis = moment.utc(invoice.invoice_datetime).valueOf();
          if (
            invoice.invoice_datetime &&
            dateMillis > fechaIniMillis &&
            dateMillis < fechaFinMillis
          ) {
            if (!hashMapCountResult[invoice.state]) { hashMapCountResult[invoice.state] = 0; }
            hashMapCountResult[invoice.state] +=
              invoice.amount_total * invoice.tipo_cambio;
            if (invoice.state === 'open') {
              openInvoices.push(invoice);
            }

            if (invoice.state === 'paid') {
              paidInvoices.push(invoice);
            }
          }
        }
      });

      resolve({ hashMapCountResult, openInvoices, paidInvoices });
    }));
  };
  this.getInvoicesData = function () {
    const facturacion = this;
    return new Promise(((resolve, reject) => {
      restServiceInstance
        .getInvoices()
        .then((invoices) => {
          facturacion.invoices = invoices;
          resolve(invoices);
        })
        .catch((error) => {
          console.log('ERROR on factuacion controller', error);
          reject(error);
        });
    }));
  };
}
export {indicadorFacturacion};
